const createQueryKey = (id: number, includeIdInKey: boolean = false) => {
    return ['meet-the-team', 'property', ...(includeIdInKey ? [id] : [])];
};

export { createQueryKey };
